export default __webpack_public_path__ + "static/Marcel_van_den_Dobbelsteen_5-45728fdc0e13e1500b692da5ddc1fba0.jpg";